const getStatusLabel = (status, i18n) => {
    return { en: status === null || status === void 0 ? void 0 : status.nameEN, pl: status === null || status === void 0 ? void 0 : status.namePL }[i18n.language];
};
export default getStatusLabel;
